import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import React, { useRef } from 'react';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import PolicyDocumentActions from '../Help/PolicyDocumentActions';
import PrivacyPolicyComponent from '../Help/PrivacyPolicyComponent';
import TermsOfService from '../Help/TermsOfService';
import TermsOfPayment from '../Help/TermsOfPayment';
import { theme } from '../../../shared/theme';

export enum Policy {
    PrivacyPolicy = 'PrivacyPolicy',
    TermsOfService = 'TermsOfService',
    TermsOfPayment = 'TermsOfPayment',
}
interface ModalProps {
    policy: Policy;
    open: boolean;
    onClose: () => void;
}

const PolicyModal = ({ policy, open, onClose }: ModalProps) => {
    const termsOfPaymentRef = useRef<HTMLDivElement>(null);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                variant='h1'
                sx={{
                    textAlign: 'left',
                    textTransform: 'uppercase',
                    fontSize: '18px',
                }}
                gutterBottom
            >
                {policy === Policy.PrivacyPolicy
                    ? '7DAY Privacy Policy'
                    : policy === Policy.TermsOfService
                      ? '7DAY Terms of Service'
                      : policy === Policy.TermsOfPayment
                        ? '7DAY Terms of Payment'
                        : ''}
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {policy === Policy.PrivacyPolicy ? (
                    <PrivacyPolicyComponent />
                ) : policy === Policy.TermsOfService ? (
                    <TermsOfService />
                ) : (
                    <TermsOfPayment contentRef={termsOfPaymentRef} />
                )}
            </DialogContent>
            <DialogActions
                sx={{
                    border: `solid 1px ${theme.palette.custom.modalActionBorder}`,
                    justifyContent:
                        policy === Policy.TermsOfPayment
                            ? 'space-between'
                            : 'flex-end',
                }}
            >
                {policy === Policy.TermsOfPayment ? (
                    <PolicyDocumentActions
                        contentRef={termsOfPaymentRef}
                        title='Terms of Payment'
                    />
                ) : null}
                <CustomButton
                    color='primary'
                    variant='contained'
                    onClick={onClose}
                >
                    Close
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default PolicyModal;
